<template>
   <dashboard-layout>
      <v-container fluid class="down-top-padding py-0">
         <BaseBreadcrumb :title="page.title" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
         <v-card>
            <v-toolbar flat color="white">
               <v-toolbar-title>CMS @ Home</v-toolbar-title>
               <v-divider class="mx-4" inset vertical></v-divider>
               <v-spacer></v-spacer>
               <v-btn color="primary" dark @click="openAdd">New Item</v-btn>
            </v-toolbar>
            <v-data-table :headers="headers" :items="items" :loading="loading" class="border" no-data-text="No CMS articles">
               <template v-slot:[`item.no`]="{ index }">
                  {{ index + 1 }}
               </template>
               <template v-slot:[`item.summary`]="{ item }">
                  {{ plainText(item.summary) }}
               </template>
               <template v-slot:[`item.image`]="{ item }">
                  <a v-if="item.image" :href="assetUrl(item.imagepath, item.image)" target="_blank">{{ item.image }}</a>
                  <span v-else>-</span>
               </template>
               <template v-slot:[`item.document`]="{ item }">
                  <a v-if="item.document" :href="assetUrl(item.documentpath, item.document)" target="_blank">{{ item.document }}</a>
                  <span v-else>-</span>
               </template>
               <template v-slot:[`item.actions`]="{ item }">
                  <v-icon small class="mr-3" @click="openEdit(item)">mdi-pencil</v-icon>
                  <v-icon small @click="openDelete(item)">mdi-delete</v-icon>
               </template>
            </v-data-table>
         </v-card>

         <v-dialog v-model="dialog" max-width="780" persistent>
            <v-card>
               <v-card-title>{{ editedItem.id ? 'Edit CMS Item' : 'New CMS Item' }}</v-card-title>
               <v-card-text>
                  <v-form ref="cmsform" v-model="valid" lazy-validation>
                     <v-text-field
                        v-model="editedItem.title"
                        :rules="[v => !!v || 'Title is required']"
                        label="Title"
                        required
                     ></v-text-field>
                     <v-textarea
                        v-model="editedItem.summary"
                        label="Summary"
                        rows="3"
                     ></v-textarea>
                     <v-textarea
                        v-model="editedItem.content"
                        label="Content"
                        rows="5"
                     ></v-textarea>
                     <v-text-field
                        v-model="editedItem.orderseq"
                        label="Order"
                        type="number"
                     ></v-text-field>
                     <v-file-input
                        v-model="imageFile"
                        label="Image"
                        prepend-icon="mdi-image"
                        show-size
                     ></v-file-input>
                     <div v-if="editedItem.image" class="caption mb-2">
                        Current image:
                        <a :href="assetUrl(editedItem.imagepath, editedItem.image)" target="_blank">{{ editedItem.image }}</a>
                     </div>
                     <v-file-input
                        v-model="documentFile"
                        label="Attached Document"
                        prepend-icon="mdi-paperclip"
                        show-size
                     ></v-file-input>
                     <div v-if="editedItem.document" class="caption">
                        Current document:
                        <a :href="assetUrl(editedItem.documentpath, editedItem.document)" target="_blank">{{ editedItem.document }}</a>
                     </div>
                  </v-form>
               </v-card-text>
               <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" dark :loading="saving" @click="saveItem">Save</v-btn>
                  <v-btn color="error" dark @click="closeDialog">Cancel</v-btn>
               </v-card-actions>
            </v-card>
         </v-dialog>

         <v-dialog v-model="deleteDialog" max-width="420" persistent>
            <v-card>
               <v-card-title>Delete CMS Item</v-card-title>
               <v-card-text>
                  Confirm delete <strong>{{ deleteItem ? deleteItem.title : '' }}</strong>?
               </v-card-text>
               <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="error" dark :loading="saving" @click="confirmDelete">Delete</v-btn>
                  <v-btn color="primary" dark @click="deleteDialog = false">Cancel</v-btn>
               </v-card-actions>
            </v-card>
         </v-dialog>
      </v-container>
   </dashboard-layout>
</template>

<script>
import BaseBreadcrumb from '@/components/BaseBreadcrumb.vue'
import DashboardLayout from '@/Layouts/DashboardLayout.vue'
const axios = require('axios')

export default {
   name: 'MOACMSHome',
   components: { DashboardLayout, BaseBreadcrumb },
   data() {
      return {
         page: { title: 'CMS @ Home' },
         breadcrumbs: [
            { text: 'Dashboard', disabled: false, to: '/dashboard' },
            { text: 'CMS @ Home', disabled: true },
         ],
         loading: false,
         saving: false,
         valid: true,
         dialog: false,
         deleteDialog: false,
         editedItem: {},
         deleteItem: null,
         imageFile: null,
         documentFile: null,
         items: [],
         headers: [
            { text: 'No.', value: 'no', width: '60', sortable: false },
            { text: 'Title', value: 'title' },
            { text: 'Summary', value: 'summary' },
            { text: 'Order', value: 'orderseq', width: '100' },
            { text: 'Image', value: 'image', sortable: false },
            { text: 'Document', value: 'document', sortable: false },
            { text: 'Actions', value: 'actions', sortable: false, align: 'end', width: '120' },
         ],
      }
   },
   mounted() {
      this.loadItems()
   },
   methods: {
      loadItems() {
         this.loading = true
         axios.get('/admin/cms/list')
            .then((resp) => {
               this.items = resp.data && resp.data.status === 'OK' ? (resp.data.data || []) : []
            })
            .finally(() => {
               this.loading = false
            })
      },

      openAdd() {
         this.editedItem = {
            title: '',
            summary: '',
            content: '',
            orderseq: 0,
         }
         this.imageFile = null
         this.documentFile = null
         this.dialog = true
      },

      openEdit(item) {
         this.editedItem = Object.assign({}, item)
         this.imageFile = null
         this.documentFile = null
         this.dialog = true
      },

      closeDialog() {
         this.dialog = false
         this.editedItem = {}
         this.imageFile = null
         this.documentFile = null
      },

      saveItem() {
         if (this.$refs.cmsform && !this.$refs.cmsform.validate(true)) {
            return
         }

         this.saving = true
         var form = new FormData()
         if (this.editedItem.id) {
            form.append('id', this.editedItem.id)
         }
         form.append('title', this.editedItem.title || '')
         form.append('summary', this.editedItem.summary || '')
         form.append('content', this.editedItem.content || '')
         form.append('orderseq', this.editedItem.orderseq || 0)
         if (this.imageFile) {
            form.append('image', this.imageFile)
         }
         if (this.documentFile) {
            form.append('document', this.documentFile)
         }

         axios.post(this.editedItem.id ? '/admin/cms/update' : '/admin/cms/add', form)
            .then((resp) => {
               if (resp.data && resp.data.status === 'OK') {
                  this.closeDialog()
                  this.loadItems()
               }
            })
            .finally(() => {
               this.saving = false
            })
      },

      openDelete(item) {
         this.deleteItem = item
         this.deleteDialog = true
      },

      confirmDelete() {
         if (!this.deleteItem) {
            return
         }
         this.saving = true
         axios.post('/admin/cms/delete', { id: this.deleteItem.id })
            .then((resp) => {
               if (resp.data && resp.data.status === 'OK') {
                  this.deleteDialog = false
                  this.deleteItem = null
                  this.loadItems()
               }
            })
            .finally(() => {
               this.saving = false
            })
      },

      assetUrl(path, file) {
         if (!path || !file) {
            return '#'
         }
         return '/' + String(path).replace(/^\/+|\/+$/g, '') + '/' + file
      },

      plainText(value) {
         if (!value) {
            return ''
         }
         var div = document.createElement('div')
         div.innerHTML = value
         return div.textContent || div.innerText || ''
      },
   },
}
</script>
